export default function ContactSection() {
  return (
    <section id="contact" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-50/60 via-accent-50/40 to-background-50 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
              合作联系
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              资源投稿与合作咨询
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
              如果您有优质的影视资源希望收录，或有商务合作、广告投放需求，欢迎通过以下方式联系我们。
              糖心视频支持西瓜视频免费、免费视频网站91、91在线视频等多平台内容对接。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/60 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">投稿邮箱</div>
                <div className="text-sm font-semibold text-foreground-800">contact@tangxin.video</div>
              </div>
            </div>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 text-sm cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              了解更多
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}